import type { EndpointBuilder } from "@reduxjs/toolkit/query";
import { baseApi } from "../baseApi";

export type StoreContactSubmitRequest = {
  full_name: string;
  email?: string | null;
  phone?: string | null;
  subject?: string | null;
  message: string;
  source_page?: string | null;
};

export type StoreContactSubmitResponse = {
  id: number;
  message: string;
  status: string;
};

type Builder = EndpointBuilder<any, any, any>;

export const storeContactApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    submitStoreContactMessage: builder.mutation<
      StoreContactSubmitResponse,
      StoreContactSubmitRequest
    >({
      query: (body) => ({
        url: "/store/contact",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSubmitStoreContactMessageMutation } = storeContactApi;
